export const catalog_matrix = [
    {form_key:'pre_position_id', catalog_key:'client_user_positions'},
    {form_key:'pre_language_id', catalog_key:'client_user_languages'},
    {form_key:'pre_area_id', catalog_key:'client_user_areas'},
    {form_key:'pre_country_id', catalog_key:'countries'},
    {form_key:'client_status_id', catalog_key:'client_statuses'},
    {form_key:'pre_responsible_id', catalog_key:'none', propname:'users'},
  ]